import { ThemeUICSSObject, spacing } from '@apia/theme';
/* IMPORT HERE */

const documents: ThemeUICSSObject = {
  display: 'flex',
  flexDirection: 'column',
  gap: spacing(7),

  '.collapsiblePanel__label': {
    mb: spacing(3),
    h2: {
      m: spacing(0),
    },
  },

  '.collapsiblePanel__content': {
    '&:not([aria-hidden="true"])': {
      border: '1px solid',
      borderColor: 'palette.border.article',
    },

    '& > div > *:not(.noPadding)': {
      p: spacing(7),
    },
  },

  '.dropzone': {
    borderTop: 'none',
    borderLeft: 'none',
    borderRight: 'none',
  },

  '.entityData__actions, .processData__actions': {
    p: spacing(3),
  },
  /* PREPEND HERE */
};

export default documents;
